import axios from 'axios'

const baseurl = `${process.env.VUE_APP_API_URL}`
const url = `${baseurl}/api/v1`
class StageTwoService {
  static createStageTwo (data) {
    return axios.post(`${url}/app/stage-two/create`, data)
  }
}

export default StageTwoService
